import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const INFLUENCER_HUB_CONFIG = enabledOn(PlatformSlug.CARSBooster)

export const isInfluencerHubAvailable = (slug?: PlatformSlug) => isFeatureAvailable(INFLUENCER_HUB_CONFIG, slug)
